module.exports = __webpack_public_path__ + "img/stones-2@2x.ca5cb43.png";